module.exports = __webpack_public_path__ + "img/privacy-jobmule.b2db2fdb.png";